export default __webpack_public_path__ + "static/media/signing.b1c2113d.webp";